import React from 'react'

export default function SendBackToEmployee(props) {
  return (
    <div className="form-group custom textarea">
      <textarea
        rows="3"
        data-gramm_editor="false"
                      spellCheck="false"
        className="form-control"
        placeholder="&nbsp;"
        onChange={props.sendBackToEmployeeHandler}
        value={props.action_value?.message}
      />
      <label>Message</label>
    </div>
  )
}
